import update from 'immutability-helper';
import _ from 'lodash';

import { MemberPayload } from '../../../types/members.types';
import { NAMES as LOGIN_ACTIONS } from '../../actions/login';
import { NAMES as ORGANIZATION_ACTIONS } from '../../actions/organizations';

interface SessionStore {
  isLogged: boolean;
  userInfo: MemberPayload | null;
}

const defaultState = {
  isLogged: false,
  userInfo: null,
};

function getUserInfo(payload) {
  return {
    ...payload,
    memberships: _.keyBy(payload.memberships, 'organizationId'),
  };
}

export const session = (state: SessionStore = defaultState, action) => {
  switch (action.type) {
    case LOGIN_ACTIONS.CHECK_SESSION_SUCCESS:
      return {
        ...state,
        isLogged: true,
        userInfo: getUserInfo(action.payload),
      };

    case ORGANIZATION_ACTIONS.INVITE_ACCEPT_SUCCESS: {
      return update<any>(state, {
        userInfo: {
          memberships: {
            $merge: {
              [action.payload.organizationId]: {
                organizationId: action.payload.organizationId,
                securityGroups: action.payload.securityGroups,
              },
            },
          },
        },
      });
    }

    case LOGIN_ACTIONS.CLEAR_SESSION:
    case LOGIN_ACTIONS.LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
};
